import script from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyPage.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyPage.vue?vue&type=style&index=0&id=430d28ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430d28ae"]])

export default __exports__